<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div v-show="$route.path == '/BeerClaimReport/CostBeerClaim'" class="kt-portlet kt-portlet--mobile">
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-store"></i>
            </span>
            <h3 class="kt-portlet__head-title">{{this.$route.meta.breadcrumb}}</h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
            <div class="row">
          

           <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>ข้อมูลปี :</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'year'"
                    :name="'year'"
                    :select2-options="yearOptions"
                    v-model="year"
                    ref="year"
                  ></select2>
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">Generate Report</button>
                <button type="reset" class="btn btn-secondary" @click="formReset">ล้างค่าทั้งหมด</button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <!--begin: Table -->
          <h3 v-if="dataTable.length != 0" class="kt-section__title all text-center">ข้อมูลเบียร์เคลม ปี :{{year}}</h3>
          <h3 v-if="dataTable.length == 0" class="kt-section__title all text-center">ไม่พบข้อมูลเบียร์เคลม</h3>
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable display nowrap"
                 style="width:100%"
              >
                <thead v-if="dataTable.length != 0">
                  <tr>
                    <th class="all text-right" v-bind:colspan="brandHeader.length+brandHeader.length + brandItem.length+brandHeader.length+brandHeader.length + brandItem.length +10">
                      ข้อมูล ณ วันที่ {{reAaDateReq}}
                    </th>
                  </tr>

                  <tr>
                    <th class="all text-center" style="width: 130px" v-bind:rowspan="5">เดือน</th>
                    <th style="background-color:rgba(75,172,198,0.5);" class="all text-center" v-bind:colspan="brandItem.length + 1">อนุมัติเคลมเบียร์</th>
                    <th style="background-color:rgba(144, 238, 144);" class="all text-center" v-bind:colspan="brandHeader.length *2">สาเหตุที่เคลม</th>
                  </tr>

                  <tr>
                    <th style="background-color:rgba(144, 238, 144);" class="all text-center" v-bind:colspan="brandItem.length + 1">ประเภทถัง (ราคารวม VAT)</th>
                    <th style="background-color:rgba(247, 150, 70,0.6);" class="all text-center" v-bind:colspan="brandHeader.length">ถังชำรุด</th>
                    <th style="background-color:rgba(247, 150, 70,0.6);" class="all text-center" v-bind:colspan="brandHeader.length">น้ำเบียร์ผิดปกติ</th>
                  </tr>

                  <tr>
                    <th class="all text-center" v-for="header in brandHeader" v-bind:colspan="brandItem.filter(o => o[0] == header).length" >{{header}} </th>
                    <th class="all text-center" style="width: 50px; background-color:rgba(144, 238, 144,0.6);" v-bind:rowspan="3" >Total</th>
                    <th class="all text-center"  style="width: 60px" v-bind:rowspan="3"  v-for="header in brandHeader">{{header}}</th>
                    <th class="all text-center"  style="width: 60px" v-bind:rowspan="3"  v-for="header in brandHeader">{{header}}</th>
                  </tr>

                  <tr>
                    <th class="all text-center" style="width: 60px"  v-for="item in brandItem" >{{item[1]}}L </th>
                  </tr>
                  <tr style="background-color:rgba(247, 150, 70,0.6);" >
                    <th class="all text-center" v-for="item in brandItem" >{{item[2].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}} </th>
                  </tr>

                  <!-- January -->
                  <tr>
                    <th class="all text-left" >January {{year}}</th>
                    <!-- <th class="all text-center" v-for="item in brandItem" >
                      {{(dataTable.filter(o => o.month == 1 && o.productBrandName == item[0]).length * item[2]).toFixed(2)}}
                    </th> -->
                    <th class="all text-center" v-for="item in costMonthList[0]">
                      {{item.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                    </th>

                    <th style="background-color:rgba(144, 238, 144,0.6);" class="all text-center" >{{totalCost[0].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</th>
                    
                    <td class="all text-center" v-for="item in brandHeader" >
                      <span v-for="data in totalCostBarnd.filter(o => o.Month == 1 && o.BrandName == item && o.Type=='PROBLEM_TYPE_DAMAGED_TANK')">{{ data.Price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}} </span> 
                      <span v-if="totalCostBarnd.filter(o => o.Month == 1 && o.BrandName == item && o.Type=='PROBLEM_TYPE_DAMAGED_TANK').length == 0">0.00</span>
                    </td>

                    <td class="all text-center" v-for="item in brandHeader" >
                      <span v-for="data in totalCostBarnd.filter(o => o.Month == 1 && o.BrandName == item && o.Type=='PROBLEM_TYPE_UNUSUAL_TASTE')">{{ data.Price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span>
                      <span v-if="totalCostBarnd.filter(o => o.Month == 1 && o.BrandName == item && o.Type=='PROBLEM_TYPE_UNUSUAL_TASTE').length == 0">0.00</span>
                    </td>
                  </tr>

                  <!--February -->
                  <tr>
                    <th class="all text-left" >February {{year}}</th>
                    <!-- <th class="all text-center" v-for="item in brandItem" >
                      {{(dataTable.filter(o => o.month == 2 && o.productBrandName == item[0]).length * item[2]).toFixed(2)}}
                    </th> -->
                    <th class="all text-center" v-for="item in costMonthList[1]">
                      {{item.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                    </th>

                    <th style="background-color:rgba(144, 238, 144,0.6);" class="all text-center" >{{totalCost[1].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</th>
                    
                    <td class="all text-center" v-for="item in brandHeader" >
                      <span v-for="data in totalCostBarnd.filter(o => o.Month == 2 && o.BrandName == item && o.Type=='PROBLEM_TYPE_DAMAGED_TANK')">{{ data.Price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span>
                      <span v-if="totalCostBarnd.filter(o => o.Month == 2 && o.BrandName == item && o.Type=='PROBLEM_TYPE_DAMAGED_TANK').length == 0">0.00</span>
                    </td>

                    <td class="all text-center" v-for="item in brandHeader" >
                      <span v-for="data in totalCostBarnd.filter(o => o.Month == 2 && o.BrandName == item && o.Type=='PROBLEM_TYPE_UNUSUAL_TASTE')">{{ data.Price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span>
                      <span v-if="totalCostBarnd.filter(o => o.Month == 2 && o.BrandName == item && o.Type=='PROBLEM_TYPE_UNUSUAL_TASTE').length == 0">0.00</span>
                    </td>
                  </tr>

                  <!--March -->
                  <tr>
                    <th class="all text-left" >March {{year}}</th>
                    <!-- <th class="all text-center" v-for="item in brandItem">
                      {{(dataTable.filter(o => o.month == 3 && o.productBrandName == item[0]).length * item[2]).toFixed(2)}}
                    </th> -->
                    <th class="all text-center" v-for="item in costMonthList[2]">
                      {{item.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                    </th>

                    <th style="background-color:rgba(144, 238, 144,0.6);" class="all text-center" >
                      {{totalCost[2].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                    </th>

                    <td class="all text-center" v-for="item in brandHeader" >
                      <span v-for="data in totalCostBarnd.filter(o => o.Month == 3 && o.BrandName == item && o.Type=='PROBLEM_TYPE_DAMAGED_TANK')">{{ data.Price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span>
                      <span v-if="totalCostBarnd.filter(o => o.Month == 3 && o.BrandName == item && o.Type=='PROBLEM_TYPE_DAMAGED_TANK').length == 0">0.00</span>
                    </td>

                    <td class="all text-center" v-for="item in brandHeader">
                      <span v-for="data in totalCostBarnd.filter(o => o.Month == 3 && o.BrandName == item && o.Type=='PROBLEM_TYPE_UNUSUAL_TASTE')">{{ data.Price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span>
                      <span v-if="totalCostBarnd.filter(o => o.Month == 3 && o.BrandName == item && o.Type=='PROBLEM_TYPE_UNUSUAL_TASTE').length == 0">0.00</span>
                    </td>
                  </tr>

                  <!--April -->
                  <tr>
                    <th class="all text-left" >April {{year}}</th>
                    <!-- <th class="all text-center" v-for="item in brandItem">
                      {{(dataTable.filter(o => o.month == 4 && o.productBrandName == item[0]).length * item[2]).toFixed(2)}}
                    </th> -->
                    <th class="all text-center" v-for="item in costMonthList[3]">
                      {{item.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                    </th>

                    <th style="background-color:rgba(144, 238, 144,0.6);" class="all text-center" >{{totalCost[3].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</th>
                    
                    <td class="all text-center" v-for="item in brandHeader" >
                      <span v-for="data in totalCostBarnd.filter(o => o.Month == 4 && o.BrandName == item && o.Type=='PROBLEM_TYPE_DAMAGED_TANK')">{{ data.Price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span>
                      <span v-if="totalCostBarnd.filter(o => o.Month == 4 && o.BrandName == item && o.Type=='PROBLEM_TYPE_DAMAGED_TANK').length == 0">0.00</span>
                    </td>
                    
                    <td class="all text-center" v-for="item in brandHeader" >
                      <span v-for="data in totalCostBarnd.filter(o => o.Month == 4 && o.BrandName == item && o.Type=='PROBLEM_TYPE_UNUSUAL_TASTE')">{{ data.Price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span>
                      <span v-if="totalCostBarnd.filter(o => o.Month == 4 && o.BrandName == item && o.Type=='PROBLEM_TYPE_UNUSUAL_TASTE').length == 0">0.00</span>
                    </td>
                  </tr>

                  <!--May -->
                  <tr>
                    <th class="all text-left" >May {{year}}</th>
                    <!-- <th class="all text-center" v-for="item in brandItem" >
                      {{(dataTable.filter(o => o.month == 5 && o.productBrandName == item[0]).length * item[2]).toFixed(2)}}
                    </th> -->
                    <th class="all text-center" v-for="item in costMonthList[4]">
                      {{item.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                    </th>

                    <th style="background-color:rgba(144, 238, 144,0.6);" class="all text-center" >{{totalCost[4].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</th>
                    
                    <td class="all text-center" v-for="item in brandHeader" >
                      <span v-for="data in totalCostBarnd.filter(o => o.Month == 5 && o.BrandName == item && o.Type=='PROBLEM_TYPE_DAMAGED_TANK')">{{ data.Price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span>
                      <span v-if="totalCostBarnd.filter(o => o.Month == 5 && o.BrandName == item && o.Type=='PROBLEM_TYPE_DAMAGED_TANK').length == 0">0.00</span>
                    </td>

                    <td class="all text-center" v-for="item in brandHeader" >
                      <span v-for="data in totalCostBarnd.filter(o => o.Month == 5 && o.BrandName == item && o.Type=='PROBLEM_TYPE_UNUSUAL_TASTE')">{{ data.Price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span>
                      <span v-if="totalCostBarnd.filter(o => o.Month == 5 && o.BrandName == item && o.Type=='PROBLEM_TYPE_UNUSUAL_TASTE').length == 0">0.00</span>
                    </td>
                  </tr>

                  <!--June -->
                  <tr>
                    <th class="all text-left" >June {{year}}</th>
                    <!-- <th class="all text-center" v-for="item in brandItem" >
                      {{(dataTable.filter(o => o.month == 6 && o.productBrandName == item[0]).length * item[2]).toFixed(2)}}
                    </th> -->
                    <th class="all text-center" v-for="item in costMonthList[5]">
                      {{item.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                    </th>

                    <th style="background-color:rgba(144, 238, 144,0.6);" class="all text-center" >{{totalCost[5].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</th>
                    
                    <td class="all text-center" v-for="item in brandHeader" >
                      <span v-for="data in totalCostBarnd.filter(o => o.Month == 6 && o.BrandName == item && o.Type=='PROBLEM_TYPE_DAMAGED_TANK')">{{ data.Price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span>
                      <span v-if="totalCostBarnd.filter(o => o.Month == 6 && o.BrandName == item && o.Type=='PROBLEM_TYPE_DAMAGED_TANK').length == 0">0.00</span>
                    </td>
                    
                    <td class="all text-center" v-for="item in brandHeader" >
                      <span v-for="data in totalCostBarnd.filter(o => o.Month == 6 && o.BrandName == item && o.Type=='PROBLEM_TYPE_UNUSUAL_TASTE')">{{ data.Price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span>
                      <span v-if="totalCostBarnd.filter(o => o.Month == 6 && o.BrandName == item && o.Type=='PROBLEM_TYPE_UNUSUAL_TASTE').length == 0">0.00</span>
                    </td>
                  </tr>

                  <!--July -->
                  <tr>
                    <th class="all text-left" >July {{year}}</th>
                    <!-- <th class="all text-center" v-for="item in brandItem" >{{(dataTable.filter(o => o.month == 7 && o.productBrandName == item[0]).length * item[2]).toFixed(2)}} </th> -->
                    <th class="all text-center" v-for="item in costMonthList[6]">
                      {{item.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                    </th>
                    <th style="background-color:rgba(144, 238, 144,0.6);"  class="all text-center" >{{totalCost[6].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</th>
                    
                    <td class="all text-center" v-for="item in brandHeader" >
                      <span v-for="data in totalCostBarnd.filter(o => o.Month == 7 && o.BrandName == item && o.Type=='PROBLEM_TYPE_DAMAGED_TANK')">{{ data.Price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span>
                      <span v-if="totalCostBarnd.filter(o => o.Month == 7 && o.BrandName == item && o.Type=='PROBLEM_TYPE_DAMAGED_TANK').length == 0">0.00</span>
                    </td>
                    
                    <td class="all text-center" v-for="item in brandHeader" >
                      <span v-for="data in totalCostBarnd.filter(o => o.Month == 7 && o.BrandName == item && o.Type=='PROBLEM_TYPE_UNUSUAL_TASTE')">{{ data.Price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span>
                      <span v-if="totalCostBarnd.filter(o => o.Month == 7 && o.BrandName == item && o.Type=='PROBLEM_TYPE_UNUSUAL_TASTE').length == 0">0.00</span>
                    </td>
                  </tr>

                  <!--August -->
                  <tr>
                    <th class="all text-left" >August {{year}}</th>
                    <!-- <th class="all text-center" v-for="item in brandItem" >{{(dataTable.filter(o => o.month == 8 && o.productBrandName == item[0]).length * item[2]).toFixed(2)}} </th> -->
                    <th class="all text-center" v-for="item in costMonthList[7]">
                      {{item.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                    </th>

                    <th style="background-color:rgba(144, 238, 144,0.6);" class="all text-center" >{{totalCost[7].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</th>
                    
                    <td class="all text-center" v-for="item in brandHeader" >
                      <span v-for="data in totalCostBarnd.filter(o => o.Month == 8 && o.BrandName == item && o.Type=='PROBLEM_TYPE_DAMAGED_TANK')">{{ data.Price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span>
                      <span v-if="totalCostBarnd.filter(o => o.Month == 8 && o.BrandName == item && o.Type=='PROBLEM_TYPE_DAMAGED_TANK').length == 0">0.00</span>
                    </td>

                    <td class="all text-center" v-for="item in brandHeader" >
                      <span v-for="data in totalCostBarnd.filter(o => o.Month == 8 && o.BrandName == item && o.Type=='PROBLEM_TYPE_UNUSUAL_TASTE')">{{ data.Price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span>
                      <span v-if="totalCostBarnd.filter(o => o.Month == 8 && o.BrandName == item && o.Type=='PROBLEM_TYPE_UNUSUAL_TASTE').length == 0">0.00</span>
                    </td>
                  </tr>

                  <!--September -->
                  <tr>
                    <th class="all text-left" >September {{year}}</th>
                    <!-- <th class="all text-center" v-for="item in brandItem" >{{(dataTable.filter(o => o.month == 9 && o.productBrandName == item[0]).length * item[2]).toFixed(2)}} </th> -->
                    <th class="all text-center" v-for="item in costMonthList[8]">
                      {{item.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                    </th>

                    <th style="background-color:rgba(144, 238, 144,0.6);" class="all text-center" >{{totalCost[8].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</th>
                    
                    <td class="all text-center" v-for="item in brandHeader" >
                      <span v-for="data in totalCostBarnd.filter(o => o.Month == 9 && o.BrandName == item && o.Type=='PROBLEM_TYPE_DAMAGED_TANK')">{{ data.Price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span>
                      <span v-if="totalCostBarnd.filter(o => o.Month == 9 && o.BrandName == item && o.Type=='PROBLEM_TYPE_DAMAGED_TANK').length == 0">0.00</span>
                    </td>

                    <td class="all text-center" v-for="item in brandHeader" >
                      <span v-for="data in totalCostBarnd.filter(o => o.Month == 9 && o.BrandName == item && o.Type=='PROBLEM_TYPE_UNUSUAL_TASTE')">{{ data.Price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span>
                      <span v-if="totalCostBarnd.filter(o => o.Month == 9 && o.BrandName == item && o.Type=='PROBLEM_TYPE_UNUSUAL_TASTE').length == 0">0.00</span>
                    </td>
                  </tr>

                  <!--October -->
                  <tr>
                    <th class="all text-left" >October {{year}}</th>
                    <!-- <th class="all text-center" v-for="item in brandItem" >{{(dataTable.filter(o => o.month == 10 && o.productBrandName == item[0]).length * item[2]).toFixed(2)}} </th> -->
                    <th class="all text-center" v-for="item in costMonthList[9]">
                      {{item.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                    </th>
                    <th style="background-color:rgba(144, 238, 144,0.6);" class="all text-center" >{{totalCost[9].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</th>
                    
                    <td class="all text-center" v-for="item in brandHeader" >
                      <span v-for="data in totalCostBarnd.filter(o => o.Month == 10 && o.BrandName == item && o.Type=='PROBLEM_TYPE_DAMAGED_TANK')">{{ data.Price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span>
                      <span v-if="totalCostBarnd.filter(o => o.Month == 10 && o.BrandName == item && o.Type=='PROBLEM_TYPE_DAMAGED_TANK').length == 0">0.00</span>
                    </td>
                    
                    <td class="all text-center" v-for="item in brandHeader" >
                      <span v-for="data in totalCostBarnd.filter(o => o.Month == 10 && o.BrandName == item && o.Type=='PROBLEM_TYPE_UNUSUAL_TASTE')">{{ data.Price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span>
                      <span v-if="totalCostBarnd.filter(o => o.Month == 10 && o.BrandName == item && o.Type=='PROBLEM_TYPE_UNUSUAL_TASTE').length == 0">0.00</span>
                    </td>
                  </tr>

                  <!--November -->
                  <tr>
                    <th class="all text-left" >November {{year}}</th>
                    <!-- <th class="all text-center" v-for="item in brandItem" >{{(dataTable.filter(o => o.month == 11 && o.productBrandName == item[0]).length * item[2]).toFixed(2)}} </th> -->
                    <th class="all text-center" v-for="item in costMonthList[10]">
                      {{item.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                    </th>
                    <th style="background-color:rgba(144, 238, 144,0.6);" class="all text-center" >{{totalCost[10].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</th>
                    
                    <td class="all text-center" v-for="item in brandHeader" >
                      <span v-for="data in totalCostBarnd.filter(o => o.Month == 11 && o.BrandName == item && o.Type=='PROBLEM_TYPE_DAMAGED_TANK')">{{ data.Price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span>
                      <span v-if="totalCostBarnd.filter(o => o.Month == 11 && o.BrandName == item && o.Type=='PROBLEM_TYPE_DAMAGED_TANK').length == 0">0.00</span>
                    </td>

                    <td class="all text-center" v-for="item in brandHeader" ><span v-for="data in totalCostBarnd.filter(o => o.Month == 11 && o.BrandName == item && o.Type=='PROBLEM_TYPE_UNUSUAL_TASTE')">{{ data.Price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span>
                      <span v-if="totalCostBarnd.filter(o => o.Month == 11 && o.BrandName == item && o.Type=='PROBLEM_TYPE_UNUSUAL_TASTE').length == 0">0.00</span>
                    </td>
                  </tr>

                  <!--December  -->
                  <tr>
                    <th class="all text-left" >December {{year}}</th>
                    <!-- <th class="all text-center" v-for="item in brandItem" >{{(dataTable.filter(o => o.month == 12 && o.productBrandName == item[0]).length * item[2]).toFixed(2)}} </th> -->
                    <th class="all text-center" v-for="item in costMonthList[11]">
                      {{item.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                    </th>
                    <th style="background-color:rgba(144, 238, 144,0.6);" class="all text-center" >{{totalCost[11].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</th>
                    
                    <td class="all text-center" v-for="item in brandHeader" >
                      <span v-for="data in totalCostBarnd.filter(o => o.Month == 12 && o.BrandName == item && o.Type=='PROBLEM_TYPE_DAMAGED_TANK')">{{ data.Price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span>
                      <span v-if="totalCostBarnd.filter(o => o.Month == 12 && o.BrandName == item && o.Type=='PROBLEM_TYPE_DAMAGED_TANK').length == 0">0.00</span>
                    </td>
                    
                    <td class="all text-center" v-for="item in brandHeader" >
                      <span v-for="data in totalCostBarnd.filter(o => o.Month == 12 && o.BrandName == item && o.Type=='PROBLEM_TYPE_UNUSUAL_TASTE')">{{ data.Price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span>
                      <span v-if="totalCostBarnd.filter(o => o.Month == 12 && o.BrandName == item && o.Type=='PROBLEM_TYPE_UNUSUAL_TASTE').length == 0">0.00</span>
                    </td>
                  </tr>

                  <!-- รวม -->
                  <tr>
                      <th style="background-color:rgba(255, 255, 0);" class="all text-left">รวม</th>

                      <!-- <th style="background-color:rgba(255, 255, 0);" class="all text-center" v-for="item in brandItem">
                        {{(dataTable.filter(o => o.productBrandName == item[0]).length * item[2]).toFixed(2)}}
                      </th> -->
                      <th style="background-color:rgba(255, 255, 0);" class="all text-center" v-for="item in totalCostMonth">
                        {{item.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                      </th>

                      <th style="background-color:rgba(144, 238, 144,0.6);"  class="all text-center" v-bind:rowspan="2">
                        {{sumTotal.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                      </th>
                      
                      <td style="background-color:rgba(255, 255, 0);" class="all text-center" v-for="(item, key) in brandHeader">
                        {{sumPriceTotalbrandHeader[key].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                        <!-- <span v-for="data in totalCostBarnd.filter(o => o.BrandName == item && o.Type=='PROBLEM_TYPE_DAMAGED_TANK')" v-if="totalCostBarnd.filter(o =>  o.BrandName == item && o.Type=='PROBLEM_TYPE_DAMAGED_TANK').length > 0">
                          {{data.Price.toFixed(2)}}
                        </span> -->

                        <!-- <span v-if="totalCostBarnd.filter(o =>  o.BrandName == item && o.Type=='PROBLEM_TYPE_DAMAGED_TANK').length == 0">0.00</span> -->
                      </td>
                      
                      <td style="background-color:rgba(255, 255, 0);" class="all text-center" v-for="(item, key) in brandHeader">
                        {{sumPriceTotalbrandHeader2[key].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                        <!-- <span v-for="data in totalCostBarnd.filter(o =>  o.BrandName == item && o.Type=='PROBLEM_TYPE_UNUSUAL_TASTE')">{{data.Price.toFixed(2)}}</span>
                        <span v-if="totalCostBarnd.filter(o =>  o.BrandName == item && o.Type=='PROBLEM_TYPE_UNUSUAL_TASTE').length == 0">0.00</span> -->
                      </td>
                  </tr>

                  <!--รวมทั้งหมด  -->
                  <tr >
                    <th style="background-color:rgba(255, 255, 0);" class="all text-left" >รวมทั้งหมด</th>
                    <th style="background-color:rgba(255, 255, 0);" class="all text-right" v-bind:colspan="brandItem.length" >{{sumTotal.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</th>

                    <td class="all text-right" v-bind:colspan="brandHeader.length" >
                      <span v-for="data in sumType.filter(o =>  o.Type=='PROBLEM_TYPE_DAMAGED_TANK')">{{ data.Price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span>
                      <span v-if="sumType.filter(o =>  o.Type=='PROBLEM_TYPE_UNUSUAL_TASTE').length == 0">0.00</span>
                    </td>

                    <td class="all text-right" v-bind:colspan="brandItem.length" >
                      <span v-for="data in sumType.filter(o =>  o.Type=='PROBLEM_TYPE_UNUSUAL_TASTE')">{{ data.Price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span>
                      <span v-if="sumType.filter(o =>  o.Type=='PROBLEM_TYPE_DAMAGED_TANK').length == 0">0.00</span>
                    </td>
                  </tr>
                  
                  <tr style="background-color:rgb(0, 255, 0);">
                    <th class="all text-left">จำนวนถัง</th>
                    <!-- <th class="all text-center" v-for="item in brandItem">{{(dataTable.filter(o => o.productBrandName == item[0] && o.volume == item[1]).length).toFixed(2)}} {{item[0]}} {{item[1]}}</th> -->
                    <th class="all text-center" v-for="item in numberOfTanks">{{item.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</th>
                  </tr>

                </thead>
              </table>
            </div>
          </div>
          <!--end: Table -->

          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../router";
import select2 from "../../Shared/Select2";
import axios from "axios";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

export default {
  components: {
    select2
  },
  data: function() {
    var self = this;

    return {
      reIsInitial: true,
      dataTable:[],
      brandHeader:[],
      volume:[],
      brandItem:[],
      costMonthList :[
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
      ],
      totalCostMonth : [],
      totalCost:[0,0,0,0,0,0,0,0,0,0,0,0],
      sumTotal: 0,
      totalCostBarnd:[],
      sumType : [],
      numberOfTanks : [],
      reAaDateReq: null,
      // year : new Date().getFullYear()+543,
      year : new Date().getFullYear(),
      yearOptions: {
        placeholder: "กรุณาเลือก",
        data: [
          // { id: new Date().getFullYear()+543, text: new Date().getFullYear()+543, data: null },
          // { id: new Date().getFullYear()+542, text: new Date().getFullYear()+542, data: null },
          // { id: new Date().getFullYear()+541, text: new Date().getFullYear()+541, data: null },
          // { id: new Date().getFullYear()+540, text: new Date().getFullYear()+540, data: null },
          // { id: new Date().getFullYear()+539, text: new Date().getFullYear()+539, data: null }
          { id: new Date().getFullYear(), text: new Date().getFullYear(), data: null },
          { id: new Date().getFullYear()-1, text: new Date().getFullYear()-1, data: null },
          { id: new Date().getFullYear()-2, text: new Date().getFullYear()-2, data: null },
          { id: new Date().getFullYear()-3, text: new Date().getFullYear()-3, data: null },
          { id: new Date().getFullYear()-4, text: new Date().getFullYear()-4, data: null }
        ]
      },
      sumPriceTotalbrandHeader : [],
      sumPriceTotalCostBarnd : 0,
      sumPriceTotalbrandHeader2 : [],
      sumPriceTotalCostBarnd2 : 0,
    };
  },
  computed: {
  },
  methods: {
    formReset: function(e) {
        let self = this;
        // self.year = new Date().getFullYear()+543;
        self.year = new Date().getFullYear();
        self.dataTable = [];
        self.brandHeader = [];
        self.volume = [];
        self.brandItem = [];
        self.costMonthList = [
          [],
          [],
          [],
          [],
          [],
          [],
          [],
          [],
          [],
          [],
          [],
          [],
        ];
        self.totalCostMonth = [];
        self.totalCost = [0,0,0,0,0,0,0,0,0,0,0,0];
        self.sumTotal = 0;
        self.totalCostBarnd =[];
        self.sumType = [];
      
        $("#year")
        .val("")
        .trigger("change");

        this.formSubmit(e);
    },
    formSubmit: function(e) {
      let self = this;
      self.dataTable = [];
      self.brandHeader = [];
      self.volume = [];
      self.brandItem = [];
      self.costMonthList = [
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
      ];
      self.totalCostMonth = [];
      self.totalCost = [0,0,0,0,0,0,0,0,0,0,0,0];
      self.sumTotal = 0;
      self.totalCostBarnd =[];
      self.sumType = [];
      self.numberOfTanks = [];
      this.getDataFromApi();
      e.preventDefault();
      table.draw();
    },
     getDataFromApi() {
       let self = this;
       axios({
        method: "post",
        url: "/Api/Report/CostBeerClaim",
        data: {
          // Year : self.year-543
          Year : self.year,
          IsInitial : self.reIsInitial
        }
      })
        .then(function(response) {
          self.dataTable = response.data.data;
          self.dataTable.forEach(e => {
            let brand = self.brandHeader.includes(e.productBrandName);
            if(!brand)
            {
              self.brandHeader.push(e.productBrandName);
            }
          });
        
          // brandItem
          self.dataTable.forEach(e => {
            let brand = self.brandHeader.includes(e.productBrandName);
            if(brand)
            {
              var list = [];
              list.push(e.productBrandName,e.volume,e.price);

              var item = self.brandItem.filter(o => o[0] == e.productBrandName && o[1] == e.volume);
              if(item.length == 0)
              {
                self.brandItem.push(list);
              }
            }
          })

          // costMonthList
            for (var x = 0; x < self.costMonthList.length; x++)
            {
              for (var y = 0; y < self.brandItem.length; y++)
              {
                var costMonth = 0;
                self.costMonthList[x].push(costMonth);
              }
            }

            self.dataTable.forEach(e => {
              if (self.brandItem.length > 0)
              {
                for (var x = 0; x < self.brandItem.length; x++)
                {
                  var price = 0;
                  if (self.brandItem[x][0] == e.productBrandName && self.brandItem[x][1] == e.volume && e.price > 0 && e.month == 1)
                  {
                    self.costMonthList[e.month - 1][x] = self.costMonthList[e.month - 1][x] + e.price;
                  }

                  if (self.brandItem[x][0] == e.productBrandName && self.brandItem[x][1] == e.volume && e.price > 0 && e.month == 2)
                  {
                    self.costMonthList[e.month - 1][x] = self.costMonthList[e.month - 1][x] + e.price;
                  }

                  if (self.brandItem[x][0] == e.productBrandName && self.brandItem[x][1] == e.volume && e.price > 0 && e.month == 3)
                  {
                    self.costMonthList[e.month - 1][x] = self.costMonthList[e.month - 1][x] + e.price;
                  }

                  if (self.brandItem[x][0] == e.productBrandName && self.brandItem[x][1] == e.volume && e.price > 0 && e.month == 4)
                  {
                    self.costMonthList[e.month - 1][x] = self.costMonthList[e.month - 1][x] + e.price;
                  }

                  if (self.brandItem[x][0] == e.productBrandName && self.brandItem[x][1] == e.volume && e.price > 0 && e.month == 5)
                  {
                    self.costMonthList[e.month - 1][x] = self.costMonthList[e.month - 1][x] + e.price;
                  }

                  if (self.brandItem[x][0] == e.productBrandName && self.brandItem[x][1] == e.volume && e.price > 0 && e.month == 6)
                  {
                    self.costMonthList[e.month - 1][x] = self.costMonthList[e.month - 1][x] + e.price;
                  }

                  if (self.brandItem[x][0] == e.productBrandName && self.brandItem[x][1] == e.volume && e.price > 0 && e.month == 7)
                  {
                    self.costMonthList[e.month - 1][x] = self.costMonthList[e.month - 1][x] + e.price;
                  }

                  if (self.brandItem[x][0] == e.productBrandName && self.brandItem[x][1] == e.volume && e.price > 0 && e.month == 8)
                  {
                    self.costMonthList[e.month - 1][x] = self.costMonthList[e.month - 1][x] + e.price;
                  }

                  if (self.brandItem[x][0] == e.productBrandName && self.brandItem[x][1] == e.volume && e.price > 0 && e.month == 9)
                  {
                    self.costMonthList[e.month - 1][x] = self.costMonthList[e.month - 1][x] + e.price;
                  }

                  if (self.brandItem[x][0] == e.productBrandName && self.brandItem[x][1] == e.volume && e.price > 0 && e.month == 10)
                  {
                    self.costMonthList[e.month - 1][x] = self.costMonthList[e.month - 1][x] + e.price;
                  }

                  if (self.brandItem[x][0] == e.productBrandName && self.brandItem[x][1] == e.volume && e.price > 0 && e.month == 11)
                  {
                    self.costMonthList[e.month - 1][x] = self.costMonthList[e.month - 1][x] + e.price;
                  }

                  if (self.brandItem[x][0] == e.productBrandName && self.brandItem[x][1] == e.volume && e.price > 0 && e.month == 12)
                  {
                    self.costMonthList[e.month - 1][x] = self.costMonthList[e.month - 1][x] + e.price;
                  }
                }
              }
            })
          // end costMonthList

          // totalCostMonth
            if (self.brandItem.length > 0)
            {
              for (var x = 0; x < self.brandItem.length; x++)
              {
                var price = 0;
                self.totalCostMonth.push(price);

                for (var y = 0; y < 12; y++)
                {
                  self.totalCostMonth[x] = parseFloat(self.totalCostMonth[x]) + parseFloat(self.costMonthList[y][x]);
                }
              }
            }
          // end totalCostMonth

          self.dataTable.forEach(e => {
            self.totalCost[e.month-1] = self.totalCost[e.month-1] + e.price;
            self.sumTotal = self.sumTotal + e.price;
          })
          self.dataTable.forEach(e => {
            var data = {
              BrandName : e.productBrandName,
              Month : e.month,
              Price : e.price,
              Type : e.problemTypeCode
            }

            var list = self.totalCostBarnd.filter(o => o.BrandName == e.productBrandName && o.Month == e.month && o.Type == e.problemTypeCode)
            if(list.length != 0)
            {
              list[0].Price = list[0].Price + e.price;
            }
            else
            {
              self.totalCostBarnd.push(data)
            }

            var type = self.sumType.filter(o => o.Type == e.problemTypeCode);
            var dataType = {
              Price : e.price,
              Type : e.problemTypeCode
            }
            if(type.length != 0)
            {
              type[0].Price = type[0].Price + e.price;
            }
            else
            {
              self.sumType.push(dataType)
            }
          })

          // totalCostBarnd
            self.sumPriceTotalbrandHeader = [];
            self.sumPriceTotalbrandHeader2 = [];
            
            if (self.totalCostBarnd.length > 0)
            {
              for (var i = 0; i < self.brandHeader.length; i++)
              {
                self.sumPriceTotalCostBarnd = 0;
                self.sumPriceTotalCostBarnd2 = 0;
                for (var j = 0; j < self.totalCostBarnd.length; j++)
                {
                  if (self.brandHeader[i] == self.totalCostBarnd[j].BrandName)
                  {
                    if (self.totalCostBarnd[j].Price && self.totalCostBarnd[j].Price > 0 && self.totalCostBarnd[j].Type == "PROBLEM_TYPE_DAMAGED_TANK")
                    {
                      self.sumPriceTotalCostBarnd = parseFloat(self.sumPriceTotalCostBarnd) + parseFloat(self.totalCostBarnd[j].Price);
                    }

                    if (self.totalCostBarnd[j].Price && self.totalCostBarnd[j].Price > 0 && self.totalCostBarnd[j].Type == "PROBLEM_TYPE_UNUSUAL_TASTE")
                    {
                      self.sumPriceTotalCostBarnd2 = parseFloat(self.sumPriceTotalCostBarnd2) + parseFloat(self.totalCostBarnd[j].Price);
                    }
                  }
                }
                self.sumPriceTotalbrandHeader.push(self.sumPriceTotalCostBarnd);
                self.sumPriceTotalbrandHeader2.push(self.sumPriceTotalCostBarnd2);
              }
            }
          // end

          // จำนวนถัง
            if (self.brandItem.length > 0)
            {
              for (var x = 0; x < self.brandItem.length; x++)
              {
                var numberOfTanks = 0;
                for (var y = 0; y < self.dataTable.length; y++)
                {
                  if (self.brandItem[x][0] == self.dataTable[y].productBrandName && self.brandItem[x][1] == self.dataTable[y].volume && self.dataTable[y].price >= 0)
                  {
                    numberOfTanks++;
                  }
                }
                self.numberOfTanks.push(numberOfTanks);
              }
            }
          // end
        });
        self.reIsInitial = false;
    },
    onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    }
  },
  async mounted() {
    let self = this;
    this.getDataFromApi();
    self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");
    // self.reAaDateReq = moment().format("DD/MM/") + (new Date().getFullYear() + 543) + " " + moment().format("H:mm");
    $(this.$refs.form).validate().settings.ignore = ":hidden";
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// App/Components/Report/CostBeerClaim.vue